import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { MyPromise } from '../../interceptors/myPromise.service';

const PROCEDURES_API = `${environment.baseEndpoint}/procedures`;

@Injectable({
  providedIn: 'root',
})
export class ProcedureFourService {

  constructor(
    private http: HttpClient,
    private myPromise: MyPromise
  ) { }

  saveObjectives(stationId, objectives) {
    // tslint:disable-next-line: max-line-length
    return this.myPromise.to(this.http.post(`${PROCEDURES_API}/${stationId}/4/objectives`, { objectives }));
  }

  updateObjectives(stationId, objectives, objective_id) {
    // tslint:disable-next-line: max-line-length
    return this.myPromise.to(this.http.put(`${PROCEDURES_API}/${stationId}/4/objectives/${objective_id}`, { objectives }));
  }

  getObjectives(stationId) {
    // tslint:disable-next-line: max-line-length
    return this.myPromise.to(this.http.get(`${PROCEDURES_API}/${stationId}/4/objectives`));
  }
}
